module.exports = require('./helpers/bundle-url').getBundleURL('jHzFK') + "large-file-storage.835ab127.png";